module.exports = __webpack_public_path__ + "static/media/UY.6afe5efa.svg";